export default __webpack_public_path__ + "static/media/battery-40.70884d06.svg";